var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-charts-container"},[_c('div',{ref:_vm.chartRef,staticClass:"charts-canvas-container"})])}
var staticRenderFns = []

export { render, staticRenderFns }